import { render, staticRenderFns } from "./MemberNews.vue?vue&type=template&id=407230f0&scoped=true&"
import script from "./MemberNews.vue?vue&type=script&lang=js&"
export * from "./MemberNews.vue?vue&type=script&lang=js&"
import style0 from "./MemberNews.vue?vue&type=style&index=0&id=407230f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407230f0",
  null
  
)

export default component.exports